/*-----------------------------------------------------------------
- Fields translations
-----------------------------------------------------------------*/
export default {

    continent   : 'قاره',
    country     : 'کشور',
    province    : 'استان',
    city        : 'شهر',
    neighborhood: 'محله',
    login       : 'ورود',

};
